'use strict';

const ACTIVITY_REGEXP = /^(9\d{5}|[1,3,4,5,6]\d{6})$/;
const GUID_REGEXP = /^\w{8}-(\w{4}-){3}\w{12}$/;

module.exports = {
  isActivityNumber: (value) => ACTIVITY_REGEXP.test(value),
  isGuid: (value) => GUID_REGEXP.test(value)
};
